import React, { useState } from 'react';
import "../Dashboard/DashBoardSidebar.css";
import MediaForm from "./MediaForm";
import MediaList from "./ListMedia";
import AddNotification from "./Notification/Add_notification";
import NotificationList from "./Notification/List_Notification";
import SubscriberList from './Subscriptions/LIstSubsription';
import SendEmail from './Subscriptions/sendMail';

const Sidebar = () => {
  const [showMediaForm, setShowMediaForm] = useState(false);
  const [showMediaList, setShowMediaList] = useState(false);
  const [isMediaDropdownOpen, setIsMediaDropdownOpen] = useState(false);
  const [isNotificationDropdownOpen, setIsNotificationDropdownOpen] = useState(false);
  const [showAddNotification, setShowAddNotification] = useState(false);
  const [showNotificationList, setShowNotificationList] = useState(false);
  const [isSubscriptionDropdownOpen, setIsSubscriptionDropdownOpen] = useState(false);
  const [showSubscriberList, setShowSubscriberList] = useState(false); // New
  const [showSendMail, setShowSendMail] = useState(false); // New

  const resetAll = () => {
    setShowMediaForm(false);
    setShowMediaList(false);
    setShowAddNotification(false);
    setShowNotificationList(false);
    setShowSubscriberList(false);
    setShowSendMail(false);
  };

  // ✅ Toggle Dropdowns
  const toggleMediaDropdown = () => setIsMediaDropdownOpen(!isMediaDropdownOpen);
  const toggleNotificationDropdown = () => setIsNotificationDropdownOpen(!isNotificationDropdownOpen);
  const toggleSubscriptionDropdown = () => setIsSubscriptionDropdownOpen(!isSubscriptionDropdownOpen);

  // ✅ Handle Success Function
  const handleSuccess = () => {
    console.log("Media added successfully!");
    setShowMediaForm(false);
    setShowMediaList(true);
  };

  return (
    <div className="dashboard-container">
      <aside id="layout-menu" className="layout-menu menu-vertical menu bg-menu-theme">
        <div className="app-brand demo">
          <a href="#" className="app-brand-link">
            <span className="app-brand-logo demo">
              <img src="./Assests/Logo.png" alt="App Logo" style={{ width: '250px', height: 'auto' }} />
            </span>
          </a>
        </div>
        <div className="menu-inner-shadow"></div>
        <ul className="menu-inner py-1">
          {/* Media Section */}
          <li className="menu-item">
            <span className="menu-link media-heading" onClick={toggleMediaDropdown}>
              Media
              <i className={`bx bx-chevron-${isMediaDropdownOpen ? 'down' : 'right'} menu-icon`}></i>
            </span>
            <ul className={`submenu ${isMediaDropdownOpen ? 'open' : ''}`}>
              <li className="submenu-item">
                <a href="#" className="menu-link" onClick={() => { resetAll(); setShowMediaForm(true); }}>
                  <i className="menu-icon tf-icons bx bx-envelope"></i>
                  <div className="text-truncate">Insert Media</div>
                </a>
              </li>
              <li className="submenu-item">
                <a href="#" className="menu-link" onClick={() => { resetAll(); setShowMediaList(true); }}>
                  <i className="menu-icon tf-icons bx bx-dock-top"></i>
                  <div className="text-truncate">List Media</div>
                </a>
              </li>
            </ul>
          </li>

          {/* Notification Section */}
          <li className="menu-item">
            <span className="menu-link media-heading" onClick={toggleNotificationDropdown}>
              Notification
              <i className={`bx bx-chevron-${isNotificationDropdownOpen ? 'down' : 'right'} menu-icon`}></i>
            </span>
            <ul className={`submenu ${isNotificationDropdownOpen ? 'open' : ''}`}>
              <li className="submenu-item">
                <a href="#" className="menu-link" onClick={() => { resetAll(); setShowAddNotification(true); }}>
                  <i className="menu-icon tf-icons bx bx-bell"></i>
                  <div className="text-truncate">Add Notification</div>
                </a>
              </li>
              <li className="submenu-item">
                <a href="#" className="menu-link" onClick={() => { resetAll(); setShowNotificationList(true); }}>
                  <i className="menu-icon tf-icons bx bx-list-ul"></i>
                  <div className="text-truncate">View Notifications</div>
                </a>
              </li>
            </ul>
          </li>

          {/* Subscription Section */}
          <li className="menu-item">
            <span className="menu-link media-heading" onClick={toggleSubscriptionDropdown}>
              Subscription
              <i className={`bx bx-chevron-${isSubscriptionDropdownOpen ? 'down' : 'right'} menu-icon`}></i>
            </span>
            <ul className={`submenu ${isSubscriptionDropdownOpen ? 'open' : ''}`}>
              <li className="submenu-item">
                <a href="#" className="menu-link" onClick={() => { resetAll(); setShowSubscriberList(true); }}>
                  <i className="menu-icon tf-icons bx bx-user"></i>
                  <div className="text-truncate">List Subscribers</div>
                </a>
              </li>
              <li className="submenu-item">
                <a href="#" className="menu-link" onClick={() => { resetAll(); setShowSendMail(true); }}>
                  <i className="menu-icon tf-icons bx bx-envelope"></i>
                  <div className="text-truncate">Send Mail to Subscribers</div>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </aside>

      {/* ✅ Correctly Display Media, Notification & Subscription Components */}
      {showMediaForm && <MediaForm onClose={() => setShowMediaForm(false)} onSuccess={handleSuccess} />}
      {showMediaList && <MediaList />}
      {showAddNotification && <AddNotification onClose={() => setShowAddNotification(false)} />}
      {showNotificationList && <NotificationList />}
      {showSubscriberList && <SubscriberList onClose={() => setShowSubscriberList(false)} />} 
      {showSendMail && <SendEmail onClose={() => setShowSendMail(false)} />} 
    </div>
  );
};

export default Sidebar;
